import { Content } from './content';

export class Question extends Content{

  type:'QuestionSelect' | 'QuestionText' | 'QuestionRating';
  typeText:string;
  title:String;
  value:any = null;
  required:boolean;
  
  constructor(object = null){
    super();
    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){
    super.set(object);

    if(object.hash){
      this.hash = object.hash;
    }
    if(object.title){
      this.title = object.title;
    }
    if(object.required){
      this.required = object.required;
    }
  }


}